import type { ReactNode } from 'react'
import { AppHeader } from './AppHeader'
import { StandaloneBanner } from './StandaloneBanner'
import { TabBar } from './TabBar'

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col bg-slate-950 text-slate-100">
      <StandaloneBanner />
      <AppHeader />
      <main className="mx-auto w-full max-w-md flex-1 px-4 pb-4">{children}</main>
      <TabBar />
    </div>
  )
}
